export class Payment {
  CompanyName: string;
  CompanyIban: string;
  RemittanceInformation: string;
  AmountCurrency: number;
  IsInProgress: boolean;
  IsCompleted: boolean;
  IsCanceled: boolean;
  IsFailed: boolean;
  CanUpdateStatus: boolean;
}
